/**
 * Simple toggle function.
 * @type {NodeListOf<Element>}
 */

/**
 * Get target Element.
 * @param targetId
 * @returns {*}
 */
function targetEl(targetId) {

  if (!targetId) {
    targetId = 'body';
  }

  // Element to toggle
  let targetElement = 'body' === targetId ? document.body : document.getElementById(targetId);

  // Double check if element is not found
  if (!targetElement) {
    targetElement = document.querySelector(targetId);
  }

  if (!targetElement) {
    // what are we still doing here..
    return false;
  }

  return targetElement;
}

document.querySelectorAll('[data-toggler]').forEach(function(toggle) {
  toggle.addEventListener('click', function (e) {
    e.preventDefault();
    let targetId = this.dataset.toggler || this.getAttribute('data-toggler'),
      targetElement = targetEl(targetId);

    targetElement.classList.toggle('active');
    this.classList.toggle('active');

    let group = toggle.dataset.togglerGroup || toggle.getAttribute('data-toggler-group');
    if (group) {
      // Get items from the same hover-group
      let groupItems = document.querySelectorAll('[data-toggler-group="' + group + '"]:not([data-toggler="' + targetId + '"])');
      for (let gi = 0, gj = groupItems.length; gi < gj; gi++) {

        let targetGroupId = groupItems[gi].dataset.toggler || roupItems[gi].getAttribute('data-toggler');
        document.getElementById(targetGroupId).classList.remove('active');
        document.querySelector('[data-toggler-hover-group="' + group + '"][data-toggler-hover="' + targetGroupId + '"]').classList.remove('active');
      }
    }

    // target specific class to toggle
    let togglerClass = this.dataset.togglerClass || this.getAttribute('data-toggler-class'),
      togglerRemoveClass = this.dataset.togglerRemoveClass || this.getAttribute('data-toggler-remove-class');

    let hoverToggler = document.querySelector('[data-toggler-hover="' + this.dataset.toggler + '"]');
    if (hoverToggler) {
      hoverToggler.classList.toggle('active');
    }

    if (togglerClass) {
      if (togglerClass.includes(' ')) {
        let classes = togglerClass.split(' ');
        for (let togglerClass of classes) {
          targetElement.classList.toggle(togglerClass);
        }
      } else {
        targetElement.classList.toggle(togglerClass);
      }
    }

    if (togglerRemoveClass) {
      if (togglerRemoveClass.includes(' ')) {
        let classes = togglerRemoveClass.split(' ');
        for (let togglerRemoveClass of classes) {
          targetElement.classList.remove(togglerRemoveClass);
        }
      } else {
        targetElement.classList.remove(togglerRemoveClass);
      }
    }

    // Set body class for style-extenders
    document.body.classList.toggle(targetId + '-active');
  });
});


document.querySelectorAll('[data-toggler-hover]').forEach(function(toggle) {
  toggle.onmouseenter = function () {

    const targetId = toggle.dataset.togglerHover || toggle.getAttribute('data-toggler-hover'),
      targetElement = targetEl(targetId);

    let group = toggle.dataset.togglerHoverGroup || toggle.getAttribute('data-toggler-hover-group');
    if (group) {
      // Get items from the same hover-group
      let groupItems = document.querySelectorAll('[data-toggler-hover-group="' + group + '"]:not([data-toggler-hover="' + targetId + '"])');

      for (groupItem of groupItems) {
        if (groupItem.classList.contains('active')) {
          groupItem.classList.remove('active');
        }

        let targetGroupId = groupItem.dataset.togglerHover || groupItem.getAttribute('data-toggler-hover');
        if (targetGroupId && document.getElementById(targetGroupId).classList.contains('active')) {
          document.getElementById(targetGroupId).classList.remove('active');
        }
      }
    }

    if (targetElement) {
      targetElement.classList.add('active');
    }
    toggle.classList.add('active');

    if (window.matchMedia('(min-width: 1200px)').matches) {
      if (targetElement) {
        window.activeMenu = targetElement;
      }
      window.activeMenuToggle = toggle;
    }
  };
});

// Reset overlays
document.querySelectorAll('.menu-overlay-sub').forEach(function(overlay) {
  overlay.onmouseleave = function () {
    if (window.activeMenu) {
      setTimeout(function () {
        window.activeMenu.classList.remove('active');
        if (window.activeMenuToggle) {
          window.activeMenuToggle.classList.remove('active');
        }
      }, 500);
    }
  };
});
document.querySelectorAll('.sub-menu').forEach(function(subMenu) {
  subMenu.onmouseleave = function () {
    if (window.activeMenu) {
      setTimeout(function () {
        window.activeMenu.classList.remove('active');
        if (window.activeMenuToggle) {
          window.activeMenuToggle.classList.remove('active');
        }
      }, 500);
    }
  };
});
